import React from 'react';
import { Grid, FormLabel, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';

const RadioComponent = ({ label, name, value, options, onChange, isDesktop }) => {
    return (
        <Grid item xs={12} md={6}>
            <Grid container alignItems="center" spacing={1} sx={{ mt: -1.5, mb: 0.5 }}>
                {label ? <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                    <FormLabel component="legend">{label}</FormLabel>
                </Grid> : null}
                <Grid item xs>
                    <FormControl component="fieldset" fullWidth>
                        <RadioGroup row name={name} value={value} onChange={onChange}>
                            {options.map((option) => (
                                <FormControlLabel
                                    key={option.value}
                                    value={option.value}
                                    control={<Radio />}
                                    label={option.label}
                                />
                            ))}
                        </RadioGroup>
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default RadioComponent;
